<div class="pdf-canvas-viewer" [class.pdf-canvas-viewer--busy]="loading || error">
  <div *ngIf="!loading && !error" class="pdf-toolbar" role="toolbar" aria-label="Controles del PDF">
    <button type="button" class="pdf-zoom-button" (click)="zoomOut()" [disabled]="zoom <= minZoom" aria-label="Reducir zoom">−</button>
    <button type="button" class="pdf-zoom-value" (click)="resetZoom()" [disabled]="zoom === defaultZoom" aria-label="Restablecer zoom">{{ zoomPercent }}%</button>
    <button type="button" class="pdf-zoom-button" (click)="zoomIn()" [disabled]="zoom >= maxZoom" aria-label="Aumentar zoom">+</button>
  </div>
  <div #scroll class="pdf-scroll-container" (wheel)="onWheel($event)" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
    <div #pagesHost class="pdf-pages-host"></div>
  </div>
  <div *ngIf="loading" class="pdf-status" role="status">
    <div class="pdf-status__sheet">
      <span class="pdf-status__spinner" aria-hidden="true"></span>
      <p class="pdf-status__title">Cargando guía</p>
      <p class="pdf-status__hint">Esto puede tardar unos segundos</p>
    </div>
  </div>
  <div *ngIf="error" class="pdf-status pdf-status--error" role="alert">
    <div class="pdf-status__sheet">
      <p class="pdf-status__title">No se pudo mostrar el PDF</p>
      <p class="pdf-status__hint">{{ error }}</p>
    </div>
  </div>
</div>
